/**
 * Internal SMB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ConfigFilesAndDataMoveCheckResult } from '../model/configFilesAndDataMoveCheckResult';
// @ts-ignore
import { Device } from '../model/device';
// @ts-ignore
import { MovePaths } from '../model/movePaths';
// @ts-ignore
import { MoveProductionTestFilesResult } from '../model/moveProductionTestFilesResult';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class ProductionTestFilesAPIService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param requiredFileTypes 
     * @param requestBody 
     * @param onlyDropOffs 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getConfigFilesAndRunDataMoveCheck(requiredFileTypes: Array<'GPS' | 'MOR' | 'ADF' | 'ADF3' | 'CSQ' | 'CONFIG_COLLAR' | 'INFO_COLLAR' | 'REPORT' | 'PRX' | 'SEP' | 'VIT' | 'MIT' | 'CONFIG_DROP_OFF' | 'INFO_DROP_OFF' | 'DROP_OFF_KEY' | 'CONFIG_EXTERNAL_DROP_OFF' | 'INFO_EXTERNAL_DROP_OFF' | 'DEBUG' | 'CONFIG_TRAP' | 'LOG_TRAP' | 'INFO_TRAP' | 'ACC_BIN' | 'MAG_BIN'>, requestBody: Array<number>, onlyDropOffs?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ConfigFilesAndDataMoveCheckResult>;
    public getConfigFilesAndRunDataMoveCheck(requiredFileTypes: Array<'GPS' | 'MOR' | 'ADF' | 'ADF3' | 'CSQ' | 'CONFIG_COLLAR' | 'INFO_COLLAR' | 'REPORT' | 'PRX' | 'SEP' | 'VIT' | 'MIT' | 'CONFIG_DROP_OFF' | 'INFO_DROP_OFF' | 'DROP_OFF_KEY' | 'CONFIG_EXTERNAL_DROP_OFF' | 'INFO_EXTERNAL_DROP_OFF' | 'DEBUG' | 'CONFIG_TRAP' | 'LOG_TRAP' | 'INFO_TRAP' | 'ACC_BIN' | 'MAG_BIN'>, requestBody: Array<number>, onlyDropOffs?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ConfigFilesAndDataMoveCheckResult>>;
    public getConfigFilesAndRunDataMoveCheck(requiredFileTypes: Array<'GPS' | 'MOR' | 'ADF' | 'ADF3' | 'CSQ' | 'CONFIG_COLLAR' | 'INFO_COLLAR' | 'REPORT' | 'PRX' | 'SEP' | 'VIT' | 'MIT' | 'CONFIG_DROP_OFF' | 'INFO_DROP_OFF' | 'DROP_OFF_KEY' | 'CONFIG_EXTERNAL_DROP_OFF' | 'INFO_EXTERNAL_DROP_OFF' | 'DEBUG' | 'CONFIG_TRAP' | 'LOG_TRAP' | 'INFO_TRAP' | 'ACC_BIN' | 'MAG_BIN'>, requestBody: Array<number>, onlyDropOffs?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ConfigFilesAndDataMoveCheckResult>>;
    public getConfigFilesAndRunDataMoveCheck(requiredFileTypes: Array<'GPS' | 'MOR' | 'ADF' | 'ADF3' | 'CSQ' | 'CONFIG_COLLAR' | 'INFO_COLLAR' | 'REPORT' | 'PRX' | 'SEP' | 'VIT' | 'MIT' | 'CONFIG_DROP_OFF' | 'INFO_DROP_OFF' | 'DROP_OFF_KEY' | 'CONFIG_EXTERNAL_DROP_OFF' | 'INFO_EXTERNAL_DROP_OFF' | 'DEBUG' | 'CONFIG_TRAP' | 'LOG_TRAP' | 'INFO_TRAP' | 'ACC_BIN' | 'MAG_BIN'>, requestBody: Array<number>, onlyDropOffs?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (requiredFileTypes === null || requiredFileTypes === undefined) {
            throw new Error('Required parameter requiredFileTypes was null or undefined when calling getConfigFilesAndRunDataMoveCheck.');
        }
        if (requestBody === null || requestBody === undefined) {
            throw new Error('Required parameter requestBody was null or undefined when calling getConfigFilesAndRunDataMoveCheck.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>onlyDropOffs, 'onlyDropOffs');
        if (requiredFileTypes) {
            requiredFileTypes.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'requiredFileTypes');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/productionTestFiles/get-config-files-and-run-data-move-check`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ConfigFilesAndDataMoveCheckResult>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: requestBody,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param fakturaCode 
     * @param prioNo 
     * @param configNo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMovePaths(fakturaCode: string, prioNo?: number, configNo?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MovePaths>;
    public getMovePaths(fakturaCode: string, prioNo?: number, configNo?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MovePaths>>;
    public getMovePaths(fakturaCode: string, prioNo?: number, configNo?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MovePaths>>;
    public getMovePaths(fakturaCode: string, prioNo?: number, configNo?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (fakturaCode === null || fakturaCode === undefined) {
            throw new Error('Required parameter fakturaCode was null or undefined when calling getMovePaths.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>fakturaCode, 'fakturaCode');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>prioNo, 'prioNo');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>configNo, 'configNo');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/productionTestFiles/movePaths`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MovePaths>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param fakturaCode 
     * @param onlyDropOffs 
     * @param device 
     * @param dropOffIds 
     * @param prioNo 
     * @param configNo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveFiles(fakturaCode: string, onlyDropOffs: boolean, device: Array<Device>, dropOffIds?: Array<number>, prioNo?: number, configNo?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MoveProductionTestFilesResult>;
    public moveFiles(fakturaCode: string, onlyDropOffs: boolean, device: Array<Device>, dropOffIds?: Array<number>, prioNo?: number, configNo?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MoveProductionTestFilesResult>>;
    public moveFiles(fakturaCode: string, onlyDropOffs: boolean, device: Array<Device>, dropOffIds?: Array<number>, prioNo?: number, configNo?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MoveProductionTestFilesResult>>;
    public moveFiles(fakturaCode: string, onlyDropOffs: boolean, device: Array<Device>, dropOffIds?: Array<number>, prioNo?: number, configNo?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (fakturaCode === null || fakturaCode === undefined) {
            throw new Error('Required parameter fakturaCode was null or undefined when calling moveFiles.');
        }
        if (onlyDropOffs === null || onlyDropOffs === undefined) {
            throw new Error('Required parameter onlyDropOffs was null or undefined when calling moveFiles.');
        }
        if (device === null || device === undefined) {
            throw new Error('Required parameter device was null or undefined when calling moveFiles.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (dropOffIds) {
            dropOffIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'dropOffIds');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>fakturaCode, 'fakturaCode');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>prioNo, 'prioNo');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>configNo, 'configNo');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>onlyDropOffs, 'onlyDropOffs');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/productionTestFiles/moveFiles`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MoveProductionTestFilesResult>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: device,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param fakturaCode 
     * @param prioNo 
     * @param configNo 
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storeCollarSpecifications(fakturaCode: string, prioNo?: number, configNo?: number, file?: Blob, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<boolean>;
    public storeCollarSpecifications(fakturaCode: string, prioNo?: number, configNo?: number, file?: Blob, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<boolean>>;
    public storeCollarSpecifications(fakturaCode: string, prioNo?: number, configNo?: number, file?: Blob, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<boolean>>;
    public storeCollarSpecifications(fakturaCode: string, prioNo?: number, configNo?: number, file?: Blob, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (fakturaCode === null || fakturaCode === undefined) {
            throw new Error('Required parameter fakturaCode was null or undefined when calling storeCollarSpecifications.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>fakturaCode, 'fakturaCode');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>prioNo, 'prioNo');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>configNo, 'configNo');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (file !== undefined) {
            localVarFormParams = localVarFormParams.append('file', <any>file) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/productionTestFiles/storeCollarSpecifications`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<boolean>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param fakturaCode 
     * @param prioNo 
     * @param configNo 
     * @param file 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storeDataCheck(fakturaCode: string, prioNo?: number, configNo?: number, file?: Blob, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<boolean>;
    public storeDataCheck(fakturaCode: string, prioNo?: number, configNo?: number, file?: Blob, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<boolean>>;
    public storeDataCheck(fakturaCode: string, prioNo?: number, configNo?: number, file?: Blob, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<boolean>>;
    public storeDataCheck(fakturaCode: string, prioNo?: number, configNo?: number, file?: Blob, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (fakturaCode === null || fakturaCode === undefined) {
            throw new Error('Required parameter fakturaCode was null or undefined when calling storeDataCheck.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>fakturaCode, 'fakturaCode');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>prioNo, 'prioNo');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>configNo, 'configNo');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (file !== undefined) {
            localVarFormParams = localVarFormParams.append('file', <any>file) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/productionTestFiles/storeDataCheck`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<boolean>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
